import { BigNumber } from '@ethersproject/bignumber';
import { getLixiBagContract } from '../utils/getLixiBagContract';

export async function getGroupLocalWinningTicket(
  groupId: number,
  lixiBagAddress: string,
) {
  const contract = getLixiBagContract(lixiBagAddress);
  const ticket = (await contract.getGroupLocalWinningTicket(
    groupId,
  )) as BigNumber;
  return ticket.toNumber();
}
